import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkFullscreenDialog } from 'uitk-react-dialog';

import { FeedbackForm } from 'components/infosite/feedback/feedback-form';

export interface FeedbackDialogProps {
  onDismiss: () => void;
  onSubmit: () => void;
  analytics?: {
    setupTracker: (id: string, description: string) => { id; description; callback };
  };
}

export const FeedbackDialog: React.FunctionComponent<FeedbackDialogProps> = ({ analytics, onDismiss, onSubmit }) => (
  <UitkFullscreenDialog dialogShow={true}>
    <UitkToolbar
      type={ToolbarType.CLOSE}
      header={<LocalizedText message="hotels.infosite.feedback.takeover.title" />}
      analytics={analytics.setupTracker(':CancelFeedback', 'Cancel feedback form')}
      action={onDismiss}
    />

    <FeedbackForm submitForm={onSubmit} closeTakeover={onDismiss} />
  </UitkFullscreenDialog>
);
